module.exports = __webpack_public_path__ + "img/box-gif.d8966fcf.gif";